import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../api/api';

export const sizeApi = createApi({
  reducerPath: 'sizeApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Size'],
  endpoints: (builder) => ({
    getSizes: builder.query({
      query: (page = 1) => ({
        url: 'api/web/v1/site/size',
        method: 'GET',
        params: { page },
        tokenType: 'admin',
      }),
      providesTags: ['Size'],
    }),
    addSize: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/add-size',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
      invalidatesTags: ['Size'],
    }),
    updateSize: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/update-size',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
      invalidatesTags: ['Size'],
    }),
    deleteSize: builder.mutation({
      query: (formData) => ({
        url: 'api/web/v1/site/delete-size',
        method: 'POST',
        data: formData,
        isFormData: true,
        tokenType: 'admin',
      }),
      invalidatesTags: ['Size'],
    }),
  }),
});

export const {
  useGetSizesQuery,
  useAddSizeMutation,
  useUpdateSizeMutation,
  useDeleteSizeMutation,
} = sizeApi;
